import React, { useEffect, useState } from "react";
import { Box, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPage } from "../../redux/Slice/Dashboard/leftNavSlice";
import CallsSubNav, { CALLS_SECTIONS } from "../../components/Calls/CallsSubNav";
import CallsOverview from "../../components/Calls/CallsOverview";
import CallsAgentReport from "../../components/Calls/CallsAgentReport";
import CallLogsTable from "../../components/Calls/CallLogsTable";
import CallsRouting from "../../components/Calls/CallsRouting";
import CallsOfficeHours from "../../components/Calls/CallsOfficeHours";
import CallsSettings from "../../components/Calls/CallsSettings";
import PanelHeading from "../../components/Navbar/PanelHeading";

const SECTION_COMPONENTS = {
  overview: CallsOverview,
  logs: CallLogsTable,
  reports: CallsAgentReport,
  routing: CallsRouting,
  "office-hours": CallsOfficeHours,
  settings: CallsSettings,
};

// Routing/Office Hours/Settings all write calling config — same gate the
// backend applies via roleauth("Calls.Edit") on those routes.
const EDIT_ONLY_SECTIONS = new Set(["routing", "office-hours", "settings"]);

const CallsPage = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [section, setSection] = useState("overview");
  const userPermissions = useSelector((state) => state.userDetails.userPermissions);
  const canEdit = userPermissions == null || userPermissions?.permissions?.Calls?.Edit === true;
  // Same CALLS_SECTIONS list the sidebar uses -- single source of truth so
  // the content header's icon/description can't drift from the sidebar's own.
  const currentSection = CALLS_SECTIONS.find((s) => s.key === section);
  const CurrentSectionIcon = currentSection?.Icon;

  useEffect(() => {
    dispatch(setCurrentPage("Calls"));
  }, [dispatch]);

  // Direct URL/back-forward navigation could otherwise leave an edit-only
  // section selected after permissions load and turn out not to allow it.
  useEffect(() => {
    if (!canEdit && EDIT_ONLY_SECTIONS.has(section)) setSection("overview");
  }, [canEdit, section]);

  const SectionComponent = SECTION_COMPONENTS[section] || CallsOverview;

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        maxHeight: "100%",
        display: "flex",
        color: "text.primary",
        backgroundColor: "background.default",
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      <CallsSubNav selected={section} onSelect={setSection} canEdit={canEdit} />
      <Box sx={{ flex: 1, minWidth: 0, height: "100%", display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <PanelHeading
          title={currentSection?.label || "Overview"}
          subtitle={currentSection?.description}
          icon={
            CurrentSectionIcon && (
              <CurrentSectionIcon size="100%" color={theme.palette.text.secondary} variant="Linear" />
            )
          }
          variant="full"
        />
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            minHeight: 0,
            overflowY: "auto",
            p: { xs: 2, sm: 3, md: 4 },
            pb: {
              xs: "calc(80px + env(safe-area-inset-bottom, 0px))",
              sm: "calc(80px + env(safe-area-inset-bottom, 0px))",
              md: 6,
            },
            boxSizing: "border-box",
          }}
        >
          <SectionComponent />
        </Box>
      </Box>
    </Box>
  );
};

export default CallsPage;
